import ReactDOM from 'react-dom';
import App from './component/base/App';

ReactDOM.render(
	<App />,
	document.querySelector('#root'),
);
